class QuickAdd extends HTMLElement {
  static forms = {};
  constructor() {
    super();
  }
  connectedCallback() {
    (this.handle = this.dataset.handle),
      (this.query =
        "?section_id=product--quick-add--form&variant=" + this.dataset.id),
      this.on("click keydown", async (t) => {
        ("keydown" === t.type && "Enter" !== t.key) ||
          (t.preventDefault(),
          this.setAttribute("data-loading", !0),
          "true" === this.dataset.form
            ? await this.showForm()
            : await this.addToCart(),
          this.setAttribute("data-loading", !1));
      });
  }
  async showForm() {
    let e = !0;
    if (
      (Object.keys(QuickAdd.forms).forEach((t) => {
        (QuickAdd.forms[t].style.display =
          t === this.handle ? "block" : "none"),
          t === this.handle && (e = !1);
      }),
      e)
    ) {
      var t = await fetch(
        `${theme.urls.root}/products/${this.handle}/` + this.query
      );
      if (!t.ok)
        throw (this.setAttribute("data-loading", !1), new Error(t.status));
      var a = await t.text(),
        d = theme.utils.parseHtml(a, ".product--quick-add--form");
      (QuickAdd.forms[this.handle] = d),
        theme.drawer.querySelector('[data-view="product-form"]').appendChild(d);
    }
    theme.utils.updateRecentProducts(this.handle),
      theme.drawer.open("right", "product-form", this);
  }
  async addToCart() {
    if (theme.utils.getQuantity(this.dataset.id, this.dataset, 1))
      try {
        await theme.cart.addItem(this.dataset.id, 1),
          theme.drawer.open("right", "cart-drawer", this);
      } catch (t) {
        throw (this.setAttribute("data-loading", !1), new Error(t));
      }
  }
  static clearFormListeners() {
    window.on("theme:navigation:reloaded theme:search:reloaded", () => {
      Object.keys(QuickAdd.forms).forEach((t) => QuickAdd.forms[t].remove()),
        (QuickAdd.forms = {});
    });
  }
}
QuickAdd.clearFormListeners(),
  customElements.define("product-quick-add", QuickAdd);
